import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form } from 'react-bootstrap';
import '../utils/Tarifas.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPenToSquare} from '@fortawesome/free-solid-svg-icons';

const API_URL_TARIFAS = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/tarifas` 
  : 'http://localhost:4000/tarifas';

const Tarifas = () => {
  const [tarifas, setTarifas] = useState([]);
  const [selectedTarifa, setSelectedTarifa] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [newTarifa, setNewTarifa] = useState({
    tarifa_base: '',
    tarifa_exceso: '',
    monto_reconexion: '',
    monto_registro_socio: '',
    imagen_junta: '',
    imagen_sello: '',
    nombre_aplicacion: '',
    valor_base: '',
    porcentaje_mora: '',
    tipo_tarifa: "",         // nuevo campo
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [existsError, setExistsError] = useState('');

  useEffect(() => {
    fetchTarifas();
  }, []);

  const fetchTarifas = async () => {
    try {
      const response = await axios.get(API_URL_TARIFAS);
      setTarifas(response.data);
    } catch (error) {
      console.error('Error fetching tarifas data:', error);
    }
  };

  const handleAddTarifa = async (e) => {
    e.preventDefault();
  
    // Validación de campos: asegurarse de que todos los campos estén completos
    const { tarifa_base, tarifa_exceso, monto_reconexion, monto_registro_socio, nombre_aplicacion, valor_base, porcentaje_mora, tipo_tarifa } = newTarifa;
    if (!tarifa_base || !tarifa_exceso || !monto_reconexion || !monto_registro_socio || !nombre_aplicacion || !valor_base || !porcentaje_mora || !tipo_tarifa) {
      setErrorMessage('Todos los campos son obligatorios.');
      return;
    }
  
    try {
      // Crear un objeto FormData para enviar tanto los datos como los archivos
      const formData = new FormData();
      
      // Agregar los datos de la tarifa (campos de texto)
      formData.append('tarifa_base', tarifa_base);
      formData.append('tarifa_exceso', tarifa_exceso);
      formData.append('monto_reconexion', monto_reconexion);
      formData.append('monto_registro_socio', monto_registro_socio);
      formData.append('nombre_aplicacion', nombre_aplicacion);
      formData.append('valor_base', valor_base);
      formData.append('porcentaje_mora', porcentaje_mora);
      formData.append('tipo_tarifa', tipo_tarifa);
      
      // Si hay imágenes, las agregamos a FormData
      if (newTarifa.imagen_junta) {
        formData.append('imagen_junta', newTarifa.imagen_junta);
      }
      if (newTarifa.imagen_sello) {
        formData.append('imagen_sello', newTarifa.imagen_sello);
      }
  
      // Mostrar los datos que se enviarán
      console.log('Datos a enviar al backend:', formData);
  
      // Enviar los datos con axios, configurando Content-Type como multipart/form-data
      await axios.post(API_URL_TARIFAS, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Es necesario para enviar archivos
        },
      });
  
      // Llamar a las funciones para actualizar la vista y cerrar el modal
      fetchTarifas();
      handleCloseModal();
    } catch (error) {
      console.error('Error al agregar tarifa:', error);
      setErrorMessage('Error al agregar la tarifa.');
    }
  };
  

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setNewTarifa({
      tarifa_base: '',
      tarifa_exceso: '',
      monto_reconexion: '',
      monto_registro_socio: '',
      imagen_junta: '',
      imagen_sello: '',
      nombre_aplicacion: '',
      valor_base: '',
      porcentaje_mora: '',
      
    });
    setErrorMessage('');
    setExistsError('');
  };

  const handleOpenEditModal = (tarifa) => {
    setSelectedTarifa(tarifa);
    setShowEditModal(true);
  };
  
  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedTarifa(null);
    setErrorMessage(null); // Limpia el mensaje de error
  };

  
  const handleUpdateTarifa = async (e) => {
    e.preventDefault();
  
    if (!selectedTarifa) return;
  
    // Validación de campos requeridos
    if (!selectedTarifa.tarifa_base || !selectedTarifa.tarifa_exceso || !selectedTarifa.tipo_tarifa) {
      setErrorMessage('Por favor, completa todos los campos requeridos.');
      return;
    }
  
    // Validación adicional para tipo_tarifa
    if (!selectedTarifa.tipo_tarifa || (selectedTarifa.tipo_tarifa !== 'Domestica' && selectedTarifa.tipo_tarifa !== 'Comercial')) {
      setErrorMessage('Por favor, selecciona un tipo de tarifa válido.');
      return;
    }console.log('Tipo de tarifa:', selectedTarifa.tipo_tarifa);
    console.log('Datos completos enviados:', selectedTarifa);
    
  
    // Imprimir los datos de selectedTarifa para verificar si tipo_tarifa está presente
    console.log('Datos que se enviarán al backend:', selectedTarifa);
  
    const formData = new FormData();
    formData.append('tarifa_base', selectedTarifa.tarifa_base);
    formData.append('tarifa_exceso', selectedTarifa.tarifa_exceso);
    formData.append('monto_reconexion', selectedTarifa.monto_reconexion);
    formData.append('monto_registro_socio', selectedTarifa.monto_registro_socio);
    formData.append('nombre_aplicacion', selectedTarifa.nombre_aplicacion);
    formData.append('valor_base', selectedTarifa.valor_base);
    formData.append('porcentaje_mora', selectedTarifa.porcentaje_mora);
    formData.append('tipo_tarifa', selectedTarifa.tipo_tarifa); // Asegúrate de que este valor esté presente
  
    if (selectedTarifa.imagen_junta) {
      formData.append('imagen_junta', selectedTarifa.imagen_junta);
    }
    if (selectedTarifa.imagen_sello) {
      formData.append('imagen_sello', selectedTarifa.imagen_sello);
    }
  
    // Enviar los datos al backend
    try {
      await axios.put(`${API_URL_TARIFAS}/${selectedTarifa.id_tarifa}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      fetchTarifas(); // Refresca la lista de tarifas
      handleCloseEditModal(); // Cierra el modal
    } catch (error) {
      console.error('Error updating tarifa:', error);
      setErrorMessage('No se pudo actualizar la tarifa.');
    }
  };
  
  
  const handleDelete = (tarifa) => {
    setSelectedTarifa(tarifa);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`${API_URL_TARIFAS}/${selectedTarifa.id_tarifa}`);
      fetchTarifas();
      setShowDeleteConfirm(false);
    } catch (error) {
      console.error('Error deleting tarifa:', error);
    }
  };

  const cancelDelete = () => {
    setShowDeleteConfirm(false);
  };

  return (
<div className="tarifas-panel">
  <div className="header-buttons">
    <Button variant="primary" onClick={handleOpenModal}>+ Nueva Tarifa</Button>
  </div>

  <h2>Gestión de Tarifas</h2>
  <div className="tarifas-panel1">
    <table className="tarifas-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Tarifa Base m3</th>
          <th>Tarifa Exceso m3</th>
          <th>Monto Reconección</th>
          <th>Monto Registro Socio</th>
          <th>Imagen Junta</th>
          <th>Imagen Sello</th>
          <th>Nombre Aplicación</th>
          <th>Valor Base $</th>
          <th>Valor de Mora $</th>
          <th>Tipo de tarifa</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {tarifas.map((tarifa) => {
          // Verificamos la extensión del archivo de la imagen (sin depender del tipo MIME)
          const validImageExtensions = ['.jpeg', '.jpg', '.png'];
          
          const isValidImagenJunta = tarifa.imagen_junta && validImageExtensions.some(ext => tarifa.imagen_junta.toLowerCase().endsWith(ext));
          const isValidImagenSello = tarifa.imagen_sello && validImageExtensions.some(ext => tarifa.imagen_sello.toLowerCase().endsWith(ext));
          
          return (
            <tr key={tarifa.id_tarifa}>
              <td>{tarifa.id_tarifa}</td>
              <td>{tarifa.tarifa_base}</td>
              <td>{tarifa.tarifa_exceso}</td>
              <td>{tarifa.monto_reconexion}</td>
              <td>{tarifa.monto_registro_socio}</td>
              <td>
                {isValidImagenJunta ? (
                  <img
                  src={process.env.REACT_APP_API_URL + `/images/${tarifa.imagen_junta}`} // Usa la variable de entorno
                  //src={`http://localhost:4000/images/${tarifa.imagen_junta}`}
                  alt="Imagen Junta"
                  width="90"
                  height="100"
                />
                
                ) : (
                  <span>Imagen no válida</span>
                )}
              </td>
              <td>
                {isValidImagenSello ? (
                  <img
                    src={process.env.REACT_APP_API_URL + `/images/${tarifa.imagen_sello}`} // Usa la variable de entorno
                    //src={`http://localhost:4000/images/${tarifa.imagen_sello}`}
                    alt="Imagen Sello"
                    width="90"
                    height="100"
                  />
                ) : (
                  <span>Imagen no válida</span>
                )}
              </td>
              <td>{tarifa.nombre_aplicacion}</td>
              <td>{tarifa.valor_base}</td>
              <td>{tarifa.porcentaje_mora}</td>
              <td>{tarifa.tipo_tarifa}</td>
             
              <td className="buttons">
            
                <Button variant="success" className="action-button" onClick={() => handleOpenEditModal(tarifa)}><FontAwesomeIcon icon={faPenToSquare} /></Button> 
                <Button variant="danger" className="action-button delete-button" onClick={() => handleDelete(tarifa)}><FontAwesomeIcon icon={faTrash} /></Button>
            </td> 
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>



      {/* Modal para agregar una nueva tarifa */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Nueva Tarifa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage && (
            <div className="alert alert-danger mt-3">
              {errorMessage}
            </div>
          )}
          <Form onSubmit={handleAddTarifa} className="tarifa-form">
            <Form.Group>
              <Form.Label>Tarifa Base m3</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={newTarifa.tarifa_base}
                onChange={(e) => setNewTarifa({ ...newTarifa, tarifa_base: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Valor Base $</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={newTarifa.valor_base}
                onChange={(e) => setNewTarifa({ ...newTarifa, valor_base: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Tarifa Exceso m3</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={newTarifa.tarifa_exceso}
                onChange={(e) => setNewTarifa({ ...newTarifa, tarifa_exceso: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Valor de Mora $</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={newTarifa.porcentaje_mora}
                onChange={(e) => setNewTarifa({ ...newTarifa, porcentaje_mora: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Monto Reconección $</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={newTarifa.monto_reconexion}
                onChange={(e) => setNewTarifa({ ...newTarifa, monto_reconexion: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Monto Registro Socio $</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={newTarifa.monto_registro_socio}
                onChange={(e) => setNewTarifa({ ...newTarifa, monto_registro_socio: e.target.value })}
                required
              />
            </Form.Group>
           
            <Form.Group controlId="tipo_tarifa">
              <Form.Label>Tipo de Tarifa</Form.Label>
              <Form.Control
                as="select"
                value={newTarifa.tipo_tarifa}
                onChange={(e) => {
                  const tipo = e.target.value;
                  console.log('Seleccionado tipo_tarifa:', tipo);  // Agregar log para ver el valor seleccionado
                  setNewTarifa({ ...newTarifa, tipo_tarifa: tipo });
                }}
                required
              >
                <option value="">Seleccione un tipo</option>
                <option value="Domestica">Doméstica</option>
                <option value="Comercial">Comercial</option>
              </Form.Control>
            </Form.Group>


            <Form.Group>
              <Form.Label>Nombre Aplicación</Form.Label>
              <Form.Control
                type="text"
                value={newTarifa.nombre_aplicacion}
                onChange={(e) => setNewTarifa({ ...newTarifa, nombre_aplicacion: e.target.value })}
                required
              />
            </Form.Group>
        
            <Form.Group>
              <Form.Label>Imagen Junta</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => setNewTarifa({ ...newTarifa, imagen_junta: e.target.files[0] })}
              />
              
            </Form.Group>
            <Form.Group>
              <Form.Label>Imagen Sello</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => setNewTarifa({ ...newTarifa, imagen_sello: e.target.files[0] })}
              />
            </Form.Group> 
            <br />
            <Button variant="primary" type="submit">Agregar Tarifa</Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal para editar una tarifa */}
      <Modal show={showEditModal} onHide={handleCloseEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Tarifa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage && (
            <div className="alert alert-danger mt-3">
              {errorMessage}
            </div>
          )}
          <Form onSubmit={handleUpdateTarifa} className="tarifa-form">
            <Form.Group>
              <Form.Label>Tarifa Base m3</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={selectedTarifa?.tarifa_base || ''}
                onChange={(e) => setSelectedTarifa({ ...selectedTarifa, tarifa_base: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Tarifa Exceso m3</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={selectedTarifa?.tarifa_exceso || ''}
                onChange={(e) => setSelectedTarifa({ ...selectedTarifa, tarifa_exceso: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Monto Reconección</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={selectedTarifa?.monto_reconexion || ''}
                onChange={(e) => setSelectedTarifa({ ...selectedTarifa, monto_reconexion: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Monto Registro Socio</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={selectedTarifa?.monto_registro_socio || ''}
                onChange={(e) => setSelectedTarifa({ ...selectedTarifa, monto_registro_socio: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Nombre Aplicación</Form.Label>
              <Form.Control
                type="text"
                value={selectedTarifa?.nombre_aplicacion || ''}
                onChange={(e) => setSelectedTarifa({ ...selectedTarifa, nombre_aplicacion: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Valor Base $</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={selectedTarifa?.valor_base || ''}
                onChange={(e) => setSelectedTarifa({ ...selectedTarifa, valor_base: e.target.value })}
                required
              />
            </Form.Group>

            <Form.Group controlId="tipo_tarifa">
            <Form.Label>Tipo de Tarifa</Form.Label>
              <Form.Control
                as="select"
                value={selectedTarifa?.tipo_tarifa || ""}
                onChange={(e) =>
                  setSelectedTarifa({
                    ...selectedTarifa,
                    tipo_tarifa: e.target.value,
                  })
                }
              >
                <option value="">Selecciona un tipo</option>
                <option value="Domestica">Doméstica</option>
                <option value="Comercial">Comercial</option>
              </Form.Control>
            </Form.Group>

            <Form.Group>
              <Form.Label>Valor de Mora $</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={selectedTarifa?.porcentaje_mora || ''}
                onChange={(e) => setSelectedTarifa({ ...selectedTarifa, porcentaje_mora: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Imagen Junta</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) =>
                  setSelectedTarifa({ ...selectedTarifa, imagen_junta: e.target.files[0] })
                }
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Imagen Sello</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) =>
                  setSelectedTarifa({ ...selectedTarifa, imagen_sello: e.target.files[0] })
                }
              />
            </Form.Group>
            
            <br /><Button variant="primary" type="submit">Actualizar Tarifa</Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal de confirmación de eliminación */}
      <Modal show={showDeleteConfirm} onHide={cancelDelete}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmación de Eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de que deseas eliminar esta tarifa?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDelete}>Cancelar</Button>
          <Button variant="danger" onClick={confirmDelete}>Eliminar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Tarifas;
